import { Box, Typography } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { ExitClicksRow } from './exitClicksModel';

/**
 * Bar chart of LEAK VOLUME by store for one band, built on Recharts (the
 * reports-suite charting choice, D-store-performance). It charts the ranked
 * leaderboard the table surfaces, and deliberately encodes magnitude ONLY: the
 * table carries the leak rate, the chart carries the absolute scale of wasted
 * traffic, so a store wasting a few hundred exits dominates the eye over one
 * wasting a handful at a worse rate. No rate is encoded here.
 *
 * Future work (D-exit-clicks): a rate-vs-volume scatter/quadrant. Not built now.
 */

const LEAK_COLOR = '#c62828';

export const ExitClicksChart = ({ rows }: { rows: ExitClicksRow[] }) => {
  const data = rows.map((r) => ({
    name: r.name,
    leakVolume: r.leakVolume,
  }));

  return (
    <Box aria-label="exit clicks chart">
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Leaked exits by store
      </Typography>
      <ResponsiveContainer width="100%" height={320}>
        <BarChart
          data={data}
          margin={{ top: 8, right: 16, bottom: 8, left: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Bar name="Leaked exits" dataKey="leakVolume" fill={LEAK_COLOR} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};
